import type { FC } from 'react';

import { FaqItem } from './fag-item';

export interface FaqListProps {
  data: {
    id: string;
    answer: React.ReactNode;
    question: React.ReactNode;
    expanded: boolean;
  }[];
  onToggle: (itemId: string) => void;
}

export const FaqList: FC<FaqListProps> = ({ data, onToggle }) => {
  return (
    <div className="flex flex-col gap-[12px]">
      {data.map(({ id, question, answer, expanded }) => (
        <FaqItem
          answer={answer}
          expanded={expanded}
          id={id}
          key={id}
          onToggle={() => onToggle(id)}
          question={question}
        />
      ))}
    </div>
  );
};
